import { useEffect, useState } from 'react';
import { useLocale } from '../context';
import { api } from '../api';

const FALLBACK_CONFIG = { groups: [] };

export function useSupportConfig() {
  const { locale } = useLocale();
  const [config, setConfig] = useState(FALLBACK_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.supportConfig(locale)
      .then((data) => {
        if (active) setConfig(data || FALLBACK_CONFIG);
      })
      .catch(() => {
        if (active) setConfig(FALLBACK_CONFIG);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [locale]);

  return { config, loading };
}

export function findSupportTemplate(config, templateId) {
  for (const group of config?.groups || []) {
    const template = group.templates?.find((item) => item.id === templateId);
    if (template) return { group, template };
  }
  return null;
}
